// extracted by mini-css-extract-plugin
module.exports = {"ButtonPanel":"ButtonPanel_ButtonPanel__3kea1","buttonWrapper":"ButtonPanel_buttonWrapper__1wKpy"};